package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Query
import com.xtream.data_kmp.FavoriteVodStreamEntity
import com.xtream.data_kmp.vodsFavoritesTable
import kotlinx.coroutines.flow.Flow


@Dao
abstract class VodsFavDao:RoomBaseInterface<FavoriteVodStreamEntity> {


    @Query("SELECT * FROM $vodsFavoritesTable")
    abstract override fun allAsFlow(): Flow<List<FavoriteVodStreamEntity>>
    @Query("SELECT * FROM $vodsFavoritesTable ")
    abstract override fun allAsPagingSource(): PagingSource<Int, FavoriteVodStreamEntity>

    @Query("SELECT EXISTS (SELECT 1 FROM $vodsFavoritesTable WHERE streamId = :id)")

    abstract override suspend fun hasEntity(id:Int):Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM $vodsFavoritesTable WHERE streamId = :id)")

    abstract override fun hasEntityAsFlow(id:Int?):Flow<Boolean>

    @Query("SELECT COUNT(*) FROM $vodsFavoritesTable")
    abstract override suspend fun getSize(): Long?
    @Query("DELETE FROM vodFavoritesTable")
    abstract override suspend fun deleteAll()

}